module.exports = __webpack_public_path__ + "static/media/GDocsPortalSiteTnC_ID.f4ad633a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust_PDF/GDocsPortalSiteTnC_ID.pdf
// module id = 693
// module chunks = 4